<template>
  <div class="letter-head flex">
    <div class="flex-1">
      <!-- <img src="http://localhost:8080/img/excavator.png" /> -->
    </div>
    <div class="text-right">
      <p class="bold">Jackson's Earthmoving</p>
      <p>17 Kendall St, Wodonga VIC 3690</p>
      <p>0438 419 256</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LetterHead'
}
</script>

<style>
  div.letter-head {
    font-weight: normal;
    border-bottom: solid 2px #eee;
    padding-bottom: 20px;
    margin-bottom:  20px;
  }

  div.letter-head img {
    height: 70px;
  }
</style>
